<template>
    <div class="balance-record-page">
      <!-- 时间筛选 -->
      <div class="filter">
        <el-date-picker
          v-model="selectedDate"
          type="month"
          placeholder="选择时间"
          @change="handleDateChange"
        ></el-date-picker>
      </div>
  
      <!-- 余额记录列表 -->
      <div class="record-list">
        <div v-if="filteredRecords.length === 0" class="empty-record">
          <img src="@/assets/logo.png" alt="暂无记录" />
          <p>暂无记录</p>
        </div>
        <el-timeline v-else>
          <el-timeline-item
            v-for="record in filteredRecords"
            :key="record.id"
            :timestamp="record.time"
          >
            {{ record.detail }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        selectedDate: new Date(),
        records: [],
        filteredRecords: []
      };
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      handleDateChange(value) {
        if (value) {
          const year = value.getFullYear();
          const month = value.getMonth() + 1; // getMonth() 返回的是 0-11
          this.fetchRecords(year, month);
        }
      },
      fetchRecords(year, month) {
        this.$axios.get('/api/show_yuer') // 替换为实际的 API 地址
          .then(response => {
            if (response.data.code === 0) {
              const data = response.data.data;
              this.records = data.map(record => ({
                id: record.id,
                time: record.time,
                detail: `${record.leixing}消费${record.money}元`
              }));
              this.filteredRecords = this.records.filter(record => {
                const recordDate = new Date(record.time);
                return recordDate.getFullYear() === year && recordDate.getMonth() === month - 1;
              }).sort((a, b) => b.id - a.id); // 按 id 逆序排序
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            this.$message.error('获取余额记录失败');
            console.error(error);
          });
      }
    },
    mounted() {
      const now = new Date();
      this.handleDateChange(now); // 默认加载当前月份的记录
    }
  };
  </script>
  
  <style scoped>
  .balance-record-page {
    padding: 16px;
    background-color: #f5f7fa;
    min-height: 100vh;
  }
  
  .filter {
    margin-bottom: 16px;
  }
  
  .record-list {
    background-color: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .empty-record {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    color: #999;
  }
  
  .empty-record img {
    width: 100px;
    height: 100px;
  }
  </style>